import React from 'react'
import { Form, Col, InputGroup, Row } from 'react-bootstrap'
import Checkbox from '../../../../components/component-items/checkbox'
import { CompanyBasicInfoFieldsProps } from '../types'

export const CompanyBasicInfoFields = ({ settings, setSettings, validated, context }: CompanyBasicInfoFieldsProps) => {
  const showField = (field: keyof typeof settings) => {
    if (context === 'warehouse') return true
    const companyFields: (keyof typeof settings)[] = ['name', 'supportEmail']
    return companyFields.includes(field)
  }

  return (
    <Row style={{ marginTop: '.8em', marginBottom: '2em' }}>
      {showField('name') && (
        <Form.Group as={Col} md="6" controlId="companyName" className="required">
          <Form.Label>Name</Form.Label>
          <Form.Control
            required
            type="text"
            placeholder="Company Name"
            value={settings.name}
            onChange={(e) => setSettings({ ...settings, name: e.target.value })}
            isInvalid={validated && !settings.name}
          />
          <Form.Control.Feedback type="invalid">Please enter the company's full name.</Form.Control.Feedback>
        </Form.Group>
      )}

      {showField('fulfillmentName') && (
        <Form.Group as={Col} md="6" controlId="fulfillmentName" className="required">
          <Form.Label>Fulfillment Name</Form.Label>
          <Form.Control
            required
            placeholder="Fulfillment Name"
            value={settings.fulfillmentName}
            onChange={(e) => setSettings({ ...settings, fulfillmentName: e.target.value })}
          />
        </Form.Group>
      )}

      {showField('supportEmail') && (
        <Form.Group as={Col} md="6" controlId="supportEmail" className="required">
          <Form.Label>Support Email</Form.Label>
          <InputGroup>
            <Form.Control
              type="email"
              placeholder="Email"
              required
              value={settings.supportEmail}
              onChange={(e) => setSettings({ ...settings, supportEmail: e.target.value })}
              isInvalid={validated && !settings.supportEmail}
            />
            <InputGroup.Text>@</InputGroup.Text>
          </InputGroup>
          <Form.Control.Feedback type="invalid">Please provide a valid support email.</Form.Control.Feedback>
        </Form.Group>
      )}

      {showField('grading') && (
        <Form.Group as={Col} md="6" controlId="grading" className="required">
          <Form.Label>Company Grading</Form.Label>
          <Form.Select value={settings.grading} onChange={(e) => setSettings({ ...settings, grading: e.target.value })}>
            <option value={'10'}>A Grade</option>
            <option value={'20'}>B Grade</option>
            <option value={'30'}>C Grade</option>
          </Form.Select>
        </Form.Group>
      )}

      {showField('wireTransferMerchant') && (
        <Col md="6">
          <InputGroup>
            <Checkbox
              selected={settings.wireTransferMerchant}
              setSelected={() => setSettings({ ...settings, wireTransferMerchant: !settings.wireTransferMerchant })}
            />
            <p style={{ padding: '0 1em' }}>Wire Transfer Merchant</p>
          </InputGroup>
        </Col>
      )}
    </Row>
  )
}
